import * as types from "./actionTypes";

const initialState = {
  loading: false,
  error: null,
  userJobs: [],
};

const sermonStudiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SAVE_YOUTUBE_PLAN_REQUEST:
    case types.FETCH_USER_JOBS_REQUEST:
      return { ...state, loading: true };
    case types.SAVE_YOUTUBE_PLAN_SUCCESS:
      return { ...state, loading: false };
    case types.FETCH_USER_JOBS_SUCCESS:
      return { ...state, loading: false, userJobs: action.payload.data || [] };
    case types.SAVE_YOUTUBE_PLAN_FAILURE:
    case types.FETCH_USER_JOBS_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default sermonStudiesReducer;
